export default __webpack_public_path__ + "static/media/investors_logo16.05145df4.png";